const ourPickProperties = (item: { [index: string]: unknown }, propertyNames: string[]) => {
  return propertyNames.reduce((result, propertyName) => {
    return { ...result, [propertyName]: item[propertyName] };
  }, {});
};

export default ourPickProperties;
